export default __webpack_public_path__ + "static/media/za.0386a651.svg";